// extracted by mini-css-extract-plugin
export default {"main":"company_main__KN24Y"};